export const PAYMENT_METHODS = {
  CREDIT_CARD: 'credit_card',
  STORED_PAYMENT: 'stored_payment',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  PIX: 'pix',
  HOLD_RESERVATION: 'hold_reservation',
  CASH: 'cash',
  TERMINAL: 'terminal',
  INVOICE: 'invoice',
  BLIK: 'blik',
  NATIVE_GOOGLE_PAY: 'native_google_pay',
  IDEAL: 'ideal',
  CHECKOUTCOM_FLOW: 'checkoutcom_flow',
  SEPA_DIRECT_DEBIT: 'sepa_direct_debit',
  MERCADO_PAGO: 'mp',
  OXXO: 'ox',
  DANA: 'dana',
  GCASH: 'gcash',
} as const
